module.exports = __webpack_public_path__ + "img/isotipo-escudo-ajustado.e0716c1a.svg";